module.exports = __webpack_public_path__ + "img/btn-fantasy-football-thin.24734fc3.png";